import Dashboard from "./dashboard";

export default class DashboardAccessAPI extends Dashboard {
  constructor() {
    super();
  }

  _tokenParams() {
    return {
      accessToken: localStorage.getItem("accessToken"),
      user: localStorage.getItem("accessUser"),
    };
  }

  getDashboardUsers() {
    return this.api
      .get("/admin/dashboard-users", { params: this._tokenParams() })
      .then((r) => r.data);
  }

  postDashboardUsers(body) {
    return this.api
      .post("/admin/dashboard-users", body, { params: this._tokenParams() })
      .then((r) => r.data);
  }

  getTsgAdmins() {
    return this.api
      .get("/admin/tsg-admins", { params: this._tokenParams() })
      .then((r) => r.data);
  }

  postTsgAdmins(body) {
    return this.api
      .post("/admin/tsg-admins", body, { params: this._tokenParams() })
      .then((r) => r.data);
  }

  getDashboardGroups() {
    return this.api
      .get("/admin/dashboard-groups", { params: this._tokenParams() })
      .then((r) => r.data);
  }

  postDashboardGroups(body) {
    return this.api
      .post("/admin/dashboard-groups", body, { params: this._tokenParams() })
      .then((r) => r.data);
  }

  /**
   * Batch-resolve EventIds → names, years, stallholder/stall catalogs (TSG-admin).
   * Body: { EventIds: string[] } and/or { Events: [{ EventId }] }
   */
  resolvePermissions(body) {
    return this.api
      .post("/admin/dashboard-permissions/resolve", body, {
        params: this._tokenParams(),
      })
      .then((r) => r.data);
  }
}
